import { render, staticRenderFns } from "./TwoFactorAuthenticationForm.vue?vue&type=template&id=5a8fd28e&scoped=true&"
import script from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuthenticationForm.vue?vue&type=style&index=0&id=5a8fd28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8fd28e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
